import { configureStore } from '@reduxjs/toolkit';

import { localStorageSyncMiddleware } from './middleware/localStorageSync';
import { rootReducer } from './root';

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(localStorageSyncMiddleware),
});

export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;
